import { render, staticRenderFns } from "./BrandGuidelines.vue?vue&type=template&id=4ef41560&scoped=true"
import script from "./BrandGuidelines.vue?vue&type=script&lang=js"
export * from "./BrandGuidelines.vue?vue&type=script&lang=js"
import style0 from "./BrandGuidelines.vue?vue&type=style&index=0&id=4ef41560&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef41560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef41560')) {
      api.createRecord('4ef41560', component.options)
    } else {
      api.reload('4ef41560', component.options)
    }
    module.hot.accept("./BrandGuidelines.vue?vue&type=template&id=4ef41560&scoped=true", function () {
      api.rerender('4ef41560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/BrandGuidelines.vue"
export default component.exports